import React, { useState } from 'react';
import { addStockSplitData, saveStockSplitData } from './services/stockSplitCalenderService';

const AddStockSplitForm = ({ onClose, corporateActions }) => {
  const [formData, setFormData] = useState({
    stockname: '',
    splitratio: '',
    splitdate: '',
    status: '',
    corporateaction: '',
    sourcedon: ''
  });

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addStockSplitData(formData);
      setShowSuccessModal(true);
    } catch (error) {
      console.error('Error saving stock split:', error);
      setErrorMessage(error.message || 'Failed to save stock split.');
      setShowErrorModal(true);
    }
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    onClose();
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  };

  return (
    <>
      {!showSuccessModal && !showErrorModal && (
        <div className="modal" style={{ display: 'block'}}>
          <div className="modal-dialog" style={{ margin: 'auto', marginTop: '100px' }}>
            <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
              <div className="modal-header">
                <h5 className="modal-title">Add Stock Split</h5>
                <button type="button" className="btn-close" onClick={onClose}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit} className="row g-3">
                  <div className="mb-3">
                    <label className="form-label">Stock Name</label>
                    <input type="text" className="form-control" name="stockname" value={formData.stockname} onChange={handleInputChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Split Ratio</label>
                    <input type="text" className="form-control" name="splitratio" value={formData.splitratio} onChange={handleInputChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Split Date</label>
                    <input type="date" className="form-control" name="splitdate" value={formData.splitdate} onChange={handleInputChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Source Date</label>
                    <input type="date" className="form-control" name="sourcedon" value={formData.sourcedon} onChange={handleInputChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select className="form-select" name="status" value={formData.status} onChange={handleInputChange} required>
                      <option value="">Select Status</option>
                      <option value="1">Completed</option>
                      <option value="0">Pending</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Corporate Action</label>
                    <select className="form-select" name="corporateaction" value={formData.corporateaction} onChange={handleInputChange} required>
                      <option value="">Select Corporate Action</option>
                      {corporateActions.map((action, index) => (
                        <option key={index} value={action}>{action}</option>
                      ))}
                    </select>
                  </div>
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">Add</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSuccessModal && (
        <div className="modal" style={{ display: 'block' }}>
          <div className="modal-dialog" style={{ margin: 'auto', marginTop: '100px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-success">Success</h5>
              </div>
              <div className="modal-body">
                <p>Stock split added successfully!</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-success" onClick={handleCloseSuccessModal}>OK</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showErrorModal && (
        <div className="modal" style={{ display: 'block' }}>
          <div className="modal-dialog" style={{ margin: 'auto', marginTop: '100px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger">Error</h5>
              </div>
              <div className="modal-body">
                <p>{errorMessage}</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={handleCloseErrorModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddStockSplitForm;
